import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const NotFound = () => {
  const { user } = useSelector((state) => state.user);

  const path = user?.isOnboardingCompleted ? "/" : "/onboarding/source";

  const buttonText = user?.isOnboardingCompleted ? "Go Home" : "Back to Setup";

  return (
    <main className="main" id="top">
      <div className="px-3">
        <div className="row min-vh-100 flex-center p-5">
          <div className="col-12 col-xl-10 col-xxl-8">
            <div className="row justify-content-center align-items-center g-5">
              <div className="col-12 col-lg-6 text-center order-lg-1">
                <img
                  className="img-fluid w-lg-100 d-dark-none"
                  src="/assets/img/spot-illustrations/404-illustration.png"
                  alt="404 illustration"
                  width="400"
                />
                <img
                  className="img-fluid w-md-50 w-lg-100 d-light-none"
                  src="/assets/img/spot-illustrations/dark_404-illustration.png"
                  alt="404 illustration"
                  width="540"
                />
              </div>

              <div className="col-12 col-lg-6 text-center text-lg-start">
                <img
                  className="img-fluid mb-6 w-50 w-lg-75 d-dark-none"
                  src="/assets/img/spot-illustrations/404.png"
                  alt="404"
                />
                <img
                  className="img-fluid mb-6 w-50 w-lg-75 d-light-none"
                  src="/assets/img/spot-illustrations/dark_404.png"
                  alt="404"
                />

                <h2 className="text-body-secondary fw-bolder mb-3">
                  Page Missing!
                </h2>

                <p className="text-body-tertiary mb-4">
                  The page you are looking for doesn't exist or may have been
                  moved.
                </p>

                <Link to={path} className="btn btn-lg btn-primary">
                  {buttonText}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
